export enum LoyaltyAllActionEnum {
    CONTEST_WINNER = 'contest_winner',
    DONATE_LEVEL1 = 'donate_level1',
    DONATE_LEVEL2 = 'donate_level2',
    DONATE_LEVEL3 = 'donate_level3',
    MOBILITY_TICKET = 'mobility_ticket',
    INIT = 'init',
    OTHER = 'other',
    SOLIDARITY_BIB = 'solidarity_bib',
    VOLUNTEER = 'volunteer',
    FINISH_RACE = 'FINISH_RACE',
    FINISH_RACE_WS = 'FINISH_RACE_WS',
    PARTICIPATE_RACE = 'PARTICIPATE_RACE',
    PARTICIPATE_RACE_WS = 'PARTICIPATE_RACE_WS',
}
